import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-sand py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcqplb8bhns">
        <div className="text-center" data-id="element-22" data-mp="1aogu8avtvya7">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-forest-900" data-id="element-23" data-mp="1apiff86k615n">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr4fs6q43rg" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-forest-900 sm:text-4xl" data-id="element-25" data-mp="1eqare96tek5m">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qy3n8nuul8vn">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-earth-200 bg-white p-6 shadow-sm ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rbeaot76tux" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vs1zntkn47t2">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="1vu51dav5npdm">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-forest-800 text-gold-400" data-id="element-30" data-mp="20qlpi52cu3qp">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25rsyu8k5bazh" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-earth-500" data-id="element-32" data-mp="3c6abou7sayqg">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-muted" data-id="element-33" data-mp="1h35avx7rwtxu">
                    <span className="line-through" data-id="element-34" data-mp="1h58an8yqa1fr">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-gold-500 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-forest-900" data-id="element-35" data-mp="1c6euf8s23wbw">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-forest-900" data-id="element-36" data-mp="yce3h17cjdm3">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-37" data-mp="tecjme23ja9k">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="1760tsbssbonw">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-ink" data-id="element-39" data-mp="12d7sjxwiyygk">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-600" aria-hidden="true" data-id="element-40" data-mp="en3oxqjc6ypk" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="flex-1" data-id="element-41" data-mp="hjxwnyr89qv" />
                <p className="mt-4 rounded-lg border-l-4 border-earth-500 bg-earth-100 px-4 py-3 text-sm font-semibold text-earth-700" data-id="element-42" data-mp="5b69sdx3g9lm">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl bg-forest-800 px-6 py-6 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-43" data-mp="j9w7nvrqmdb1">
          <div data-id="element-44" data-mp="o8gxd19d5el8">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-forest-100" data-id="element-45" data-mp="o6wck3cupa0k">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-forest-100/70 line-through decoration-red-300 decoration-2" data-id="element-46" data-mp="e9zzrlfx61q7">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-47" data-mp="2z1a95o2xt6gr">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-forest-100" data-id="element-48" data-mp="2yyxj0nn0zpsm">Your price today</p>
            <p className="mt-1 font-display text-3xl font-extrabold text-gold-400" data-id="element-49" data-mp="3f9zo8ofluft4">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-earth-700" data-id="element-50" data-mp="35i3prc9lwnod">
          Only included in this offer
        </p>
      </div>
    </section>;
}